import React, { FunctionComponent } from "react";
import { EvidenceColumn } from "../../../../../../store/onboarding/types";
import BellowCell from "./BelowCell";
import AtOrAboveCell from "./AtOrAboveCell";
import { BenchmarkStats } from "../hooks/useEquityBenchmarkData";

type OwnProps = {
  groupKey: string;
  label: string;
  students: number[];
  evidenceColumns: EvidenceColumn[];
  stats: Record<number, BenchmarkStats | null>;
};

type Props = OwnProps;

/**
 * Renders the two-row (Below / At-Or-Above) tbody for a single demographic
 * group (race value, special education, ELL, SLD, gender, free lunch, etc).
 * Extracted to remove the ~6x duplicated tbody blocks that previously lived
 * directly in EquityBenchmarksModalContent's render method.
 */
const DemographicGroupRows: FunctionComponent<Props> = (props) => {
  const { groupKey, label, students, evidenceColumns, stats } = props;

  return (
    <tbody key={groupKey}>
      <tr className="text-center">
        <td rowSpan={2}>{label}</td>
        {evidenceColumns.map((ec) => (
          <BellowCell key={ec.id} statsByEc={stats[ec.id]} students={students} />
        ))}
      </tr>
      <tr className="text-center">
        {evidenceColumns.map((ec) => (
          <AtOrAboveCell key={ec.id} statsByEc={stats[ec.id]} students={students} />
        ))}
      </tr>
    </tbody>
  );
};

export default DemographicGroupRows;
